import { AppState } from '../initialStateRegistration';

const getFooter = (state: AppState) => state.footer;

export const getLinksSection = (state: AppState) => getFooter(state).linksSection;

export const getSocialSection = (state: AppState) => getFooter(state).socialSection;

export const getAppsSection = (state: AppState) => getFooter(state).appsSection;

export const getBottomFooterBar = (state: AppState) => getFooter(state).bottomFooterBar;
